import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiPinflGet } from '@/entities/pinfl/modules/api/pinfl';
import { env } from '@/shared/lib/env';

export const usePinflLimit = (pinfl: string, excludeParcel?: string) => {
  const isComplete = pinfl.length === env.pinflLength && /^\d+$/.test(pinfl);
  return useFetch({
    api: () => apiPinflGet(pinfl, excludeParcel),
    keywords: queryKeys.pinfl.detail(pinfl, excludeParcel),
    enabled: isComplete,
    staleTime: 30_000,
  });
};
